module.exports = __webpack_public_path__ + "static/media/boy_dancing.12d30e68.png";